import React, { Component } from "react";
import { activeOptions, isTechnicianActive } from "../../utils/helpers";
import {
  loading,
  NavbarAdmin,
  Modal,
  DatePicker,
  Select,
  GET,
  POST,
  PUT,
  alert,
  company,
  format_date,
  t, // นำเข้าฟังก์ชัน t
  searchCustomerRows,
  mergeCustomerPins,
  addCustomerPin,
  ActionIconButton,
  ACTION_ICONS
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";

import { formatNumber } from "../../utils/formatting";
// ค่าแทน "ไม่ระบุโครงการ" ใน dropdown โครงการ (asset ที่ไม่ได้ผูกโครงการ)
const NO_PROJECT = "__no_project__";

// ความถี่ของแผน: value = ค่าที่บันทึก, months = ระยะห่างของรอบ (เดือน), labelKey = key แปลภาษา (ตัวพิมพ์เล็กของ value)
// ต้องตรงกับ FREQUENCY_INTERVAL_MONTHS ใน backend (inspection-plan.service.js)
const FREQUENCY_OPTIONS = [
  { value: "Monthly", months: 1, labelKey: "monthly" },
  { value: "Bimonthly", months: 2, labelKey: "bimonthly" },
  { value: "Quarterly", months: 3, labelKey: "quarterly" },
  { value: "SemiAnnual", months: 6, labelKey: "semiannual" },
  { value: "Yearly", months: 12, labelKey: "yearly" },
];

export default class InspectionPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      edit_uid: "",            // uid ของ plan ที่กำลังแก้ไข ("" = โหมดสร้าง)
      filter_search: "",
      filter_customer_uid: "",
      current_year: new Date().getFullYear(),

      // ===== Modal Form States (ยังไม่บันทึกจริง รอ confirm) =====
      customer_id: "",          // uid ของลูกค้า
      project_id: "",           // uid ของโครงการ (NO_PROJECT = ไม่ระบุโครงการ) - ใช้กรอง asset และบันทึกลงแผน
      asset_id: "",             // uid ของ machine/asset
      checklist_template_id: "",// uid ของ checklist template
      frequency: "Monthly",     // ดู FREQUENCY_OPTIONS
      assigned_technician_id: "", // uid ของช่าง (ตัด auto-assign ออก)
      start_date: "",           // YYYY-MM-DD
      end_date: "",             // YYYY-MM-DD
      visit_date: "",           // วันที่คาดว่าจะเข้าพบ (วันที่จริงในช่วง start-end)
      visit_day: "",            // วัน (1-31) ที่ดึงจาก visit_date = วันตั้งต้นของรอบ
      notification_days: "7",   // แจ้งเตือนล่วงหน้ากี่วัน

      // Dropdown master data (ดึงจริงจาก API)
      data_customers: [],
      customer_pins: [], // ลูกค้าที่ถูกอ้างถึงอยู่ ต้องคงไว้ในรายการแม้ผลค้นหาจะเปลี่ยน
      data_assets: [],          // เก็บ asset แบบเต็ม (มี customer_id) ไว้ filter ตามลูกค้า
      data_technicians: [],
      data_checklists: [],

      // \u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e15\u0e32\u0e23\u0e32\u0e07\u0e08\u0e23\u0e34\u0e07 (\u0e14\u0e36\u0e07\u0e08\u0e32\u0e01 API \u0e15\u0e32\u0e21\u0e1b\u0e35\u0e17\u0e35\u0e48\u0e40\u0e25\u0e37\u0e2d\u0e01)
      data: [],
      summary: { total: 0, completed: 0, upcoming: 0, overdue: 0 },
      saving: false, // กัน double submit
    };
  }

  async componentDidMount() {
    await Promise.all([this.GetOptions(), this.GetSchedule()]);
    loading(false);
    // ลิงก์จากหน้าแจ้งเตือนแผน PM: ?uid=<plan uid> -> เปิดแผนนั้นทันที
    const deepUid = new URLSearchParams(window.location.search).get("uid");
    // เอา ?uid= ออกจาก URL (คง param อื่น) กัน popup เด้งกลับตอนรีเฟรช
    if (deepUid) {
      const url = new URL(window.location.href);
      url.searchParams.delete("uid");
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    }
    if (deepUid) this.openEdit(deepUid);
  }

  // ทรัพย์สินโหลดเฉพาะของลูกค้าที่เลือกในฟอร์ม (หลักร้อย) แทนการดึงทั้งบริษัท (หลักหมื่น) ตอนเปิดหน้า
  // ทุกจุดที่เปลี่ยน customer_id (เลือกเอง / เปิดแก้ไข / รีเซ็ตฟอร์ม) มาผ่านที่นี่ที่เดียว
  componentDidUpdate(prevProps, prevState) {
    if (prevState.customer_id !== this.state.customer_id) {
      this.loadCustomerAssets(this.state.customer_id);
    }
  }

  // token กันผลลัพธ์ที่ตอบช้า (ลูกค้ารายก่อน) มาทับรายการของลูกค้าที่เลือกล่าสุด
  assetLoadToken = 0;

  loadCustomerAssets = async (customerUid) => {
    const token = ++this.assetLoadToken;

    if (!customerUid) {
      this.setState({ data_assets: [] });
      return;
    }

    // lite=true: field snapshot + customer + project สำหรับ dropdown โดยไม่ join หนัก
    const result = await GET("admin/assets", { page: 0, page_size: 10000, lite: "true", customer_id: customerUid });
    if (token !== this.assetLoadToken || !result?.status) return;

    const data_assets = (result.data || []).map((e) => ({
      ...e,
      value: e.uid,
      label:
        [this.getAssetDisplayName(e), e.asset_code, e.serial_number]
          .filter(Boolean)
          .join(" - ") || "-",
    }));

    // เปิดแก้ไขแผนที่ยังไม่ได้บันทึกโครงการ (แผนเก่า / ไม่ระบุโครงการ) -> เติมโครงการจาก asset ที่เลือกไว้
    this.setState((prevState) => {
      const selectedAsset = prevState.asset_id && !prevState.project_id ? data_assets.find((a) => a.uid === prevState.asset_id) : null;
      return selectedAsset ? { data_assets, project_id: this.getAssetProjectId(selectedAsset) } : { data_assets };
    });
  };

  // ===== ดึงข้อมูล master สำหรับ dropdown ใน modal (ของจริงจาก API) =====
  GetOptions = async () => {
    // ลูกค้าไม่โหลดยกก้อน - ค้นหาฝั่ง server ตอนพิมพ์ (searchCustomers)
    this.searchCustomers("");

    // ทรัพย์สินไม่โหลดยกก้อน - โหลดตามลูกค้าที่เลือก (loadCustomerAssets)
    const [res_technician, res_checklist] = await Promise.all([
      // lite=true: dropdown ใช้แค่ชื่อ/uid ไม่ต้อง join skills/vehicles/role
      GET("admin/technicians", { page: 0, page_size: 10000, lite: "true" }),
      GET("admin/checklist-templates", { page: 0, page_size: 10000 }),
    ]);

    this.setState({
      data_technicians:
        res_technician?.data?.map((e) => ({
          ...e,
          value: e.uid,
          label: this.getTechnicianDisplayName(e),
        })) || [],
      data_checklists:
        res_checklist?.data?.map((e) => ({
          ...e,
          value: e.uid,
          label: e.name || e.template_name || "-",
        })) || [],
    });
  };

  // ===== ดึงตารางรายปี (group ตาม asset + จำนวน visit รายเดือน) =====
  GetSchedule = async () => {
    const ceYear = this.state.current_year;
    const result = await GET("admin/inspection-plans/schedule", {
      year: ceYear,
      customer_id: this.state.filter_customer_uid || "",
      data_search: this.state.filter_search || "",
    });

    if (result?.status) {
      const payload = result.data || {};
      const data = (payload.data || []).map((asset) => ({
        plan_uid: asset.plan_uid,
        name: asset.name,
        sub: asset.sub,
        icon: "",
        total: asset.total,
        // map ให้ตรง shape เดิมของ table (val = วันที่ของ visit) + พก wo_uid/สถานะ
        schedule: (asset.schedule || []).map((s) => ({
          m: s.m,
          val: s.day || (s.date ? Number(s.date.slice(8, 10)) : s.count), // วันที่ (1-31)
          count: s.count,
          date: s.date,
          wo_uid: s.wo_uid,
          wo_status: s.status,
          status: this.mapWoStatusToColor(s.status), // สำหรับสีวงกลม
        })),
      }));
      this.setState({ data, summary: payload.summary || { total: 0, completed: 0, upcoming: 0, overdue: 0 } });
    } else {
      this.setState({ data: [], summary: { total: 0, completed: 0, upcoming: 0, overdue: 0 } });
    }
  };

  // เปลี่ยนปี (step = -1 / +1) แล้วโหลดข้อมูลใหม่
  changeYear = async (step) => {
    loading(true);
    this.setState({ current_year: this.state.current_year + step }, async () => {
      await this.GetSchedule();
      loading(false);
    });
  };

  // เปิด modal โหมดสร้าง
  openCreate = () => {
    this.resetForm();
    this.setState({ modal_create: true });
  };

  // เปิด modal โหมดแก้ไข — ดึงข้อมูล plan มา prefill
  openEdit = async (planUid) => {
    if (!planUid) return;
    loading(true);
    const result = await GET("admin/inspection-plans", { uid: planUid });
    loading(false);

    const d = result?.data;
    if (!result?.status || !d) {
      return alert("", "warning", t("warning"), result?.message || t("save_error_msg"));
    }

    const start = (d.start_date || "").slice(0, 10);
    const end = (d.end_date || "").slice(0, 10);

    // สร้าง visit_date จากเดือนของ start + visit_day (ให้ DatePicker แสดงได้ และ anchor ตรง)
    let visit_date = "";
    if (start && d.visit_day) {
      const sd = new Date(start);
      const dim = new Date(sd.getFullYear(), sd.getMonth() + 1, 0).getDate();
      const day = Math.min(d.visit_day, dim);
      visit_date = `${sd.getFullYear()}-${("0" + (sd.getMonth() + 1)).slice(-2)}-${("0" + day).slice(-2)}`;
    }

    // ลูกค้าของแผนนี้อาจไม่อยู่ในผลค้นหาปัจจุบัน ปักหมุดไว้ให้ dropdown แสดงชื่อได้
    if (d.customer?.uid) this.pinCustomer(this.toCustomerOption(d.customer));

    this.setState({
      modal_create: true,
      edit_uid: planUid,
      customer_id: d.customer?.uid || "",
      project_id: d.project?.uid || "", // ว่าง = เติมจาก asset หลังโหลดรายการของลูกค้าเสร็จ (loadCustomerAssets)
      asset_id: d.asset?.uid || "",
      checklist_template_id: d.checklist_template?.uid || "",
      frequency: d.frequency || "Monthly",
      assigned_technician_id: d.technician?.uid || "",
      start_date: start,
      end_date: end,
      visit_date,
      visit_day: d.visit_day ? String(d.visit_day) : "",
      notification_days: d.notification_day_before ? String(d.notification_day_before) : "7",
    });
  };

  // ===== คลิกวงกลม visit -> ไปหน้า Work Order แล้วเปิด modal ของ WO ตัวนั้น (ใช้ modal จริงของหน้า work-order) =====
  openWorkOrder = (woUid) => {
    if (!woUid) return;
    window.location.href = `/ad/work-orders?uid=${encodeURIComponent(woUid)}`;
  };

  // ===== Helper อ่านชื่อตามภาษา (อิง pattern จาก work-requests.js) =====
  getCurrentLang = () => localStorage.getItem("lang") || "TH";

  getCustomerDisplayName = (customer) => {
    if (this.getCurrentLang() === "EN") {
      return customer?.full_name_en || customer?.full_name_th || customer?.name || customer?.customer_code || "-";
    }
    return customer?.full_name_th || customer?.full_name_en || customer?.name || customer?.customer_code || "-";
  };

  getAssetCustomerId = (asset) =>
    asset?.customer?.uid || asset?.customer_id || asset?.customer_uid || asset?.owner_customer_id || "";

  getAssetDisplayName = (asset) =>
    asset?.part_name || asset?.part?.name || asset?.asset_name || asset?.name || "-";

  getTechnicianDisplayName = (technician) => {
    let nickname_th = technician?.nickname_th ? ` (${technician?.nickname_th})` : "";
    let nickname_en = technician?.nickname_en ? ` (${technician?.nickname_en})` : "";
    return (
      [technician?.first_name_th, technician?.last_name_th, nickname_th].filter(Boolean).join(" ") ||
      [technician?.first_name_en, technician?.last_name_en, nickname_en].filter(Boolean).join(" ") ||
      "-"
    );
  };

  // asset ที่ไม่ผูกโครงการจัดเข้ากลุ่ม "ไม่ระบุโครงการ"
  getAssetProjectId = (asset) => asset?.project?.uid || NO_PROJECT;

  // โครงการของลูกค้าที่เลือก - ดึงจาก asset ของลูกค้ารายนั้น จึงมีเฉพาะโครงการที่มี asset ให้เลือกจริง
  getProjectOptions = () => {
    const { data_assets, customer_id } = this.state;
    if (!customer_id) return [];

    const options = [];
    const seen = new Set();
    let hasNoProject = false;
    data_assets.forEach((a) => {
      if (this.getAssetCustomerId(a) !== customer_id) return;
      const project = a?.project;
      if (!project?.uid) {
        hasNoProject = true;
        return;
      }
      if (seen.has(project.uid)) return;
      seen.add(project.uid);
      options.push({ value: project.uid, label: [project.project_code, project.name].filter(Boolean).join(" ") || "-" });
    });
    options.sort((a, b) => a.label.localeCompare(b.label));
    if (hasNoProject) options.push({ value: NO_PROJECT, label: t("project_unspecified") });
    return options;
  };

  // แสดงเฉพาะ asset ของลูกค้า + โครงการที่เลือก
  getFilteredAssetOptions = () => {
    const { data_assets, customer_id, project_id } = this.state;
    if (!customer_id || !project_id) return [];
    return data_assets.filter((a) => this.getAssetCustomerId(a) === customer_id && this.getAssetProjectId(a) === project_id);
  };

  // จำนวนเดือนของแต่ละความถี่
  getFrequencyInterval = (frequency) =>
    FREQUENCY_OPTIONS.find((f) => f.value === frequency)?.months || 1;

  getFrequencyLabel = (frequency) =>
    t((FREQUENCY_OPTIONS.find((f) => f.value === frequency) || FREQUENCY_OPTIONS[0]).labelKey);

  // แปลง 'YYYY-MM-DD' เป็น Date เวลา local (กัน timezone เลื่อนวัน — new Date('YYYY-MM-DD') เป็น UTC)
  parseLocalDate = (value) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || "");
    if (!m) return new Date(NaN);
    return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  };

  // ===== คำนวณ Schedule Preview =====
  // อิงจาก start/end date + frequency + วันที่คาดว่าจะเข้าพบ (visit_day)
  // คืน array ของรอบเข้าพบ [{ year, month, day, date }]
  computeSchedule = () => {
    const { start_date, end_date, frequency, visit_day } = this.state;
    if (!start_date || !end_date) return [];

    const start = this.parseLocalDate(start_date);
    const end = this.parseLocalDate(end_date);
    if (isNaN(start.getTime()) || isNaN(end.getTime()) || end < start) return [];

    const interval = this.getFrequencyInterval(frequency);
    const anchorDay = parseInt(visit_day, 10) || start.getDate();

    const result = [];
    let y = start.getFullYear();
    let m = start.getMonth();
    let guard = 0;

    while (guard < 600) {
      guard += 1;
      const daysInMonth = new Date(y, m + 1, 0).getDate();
      const day = Math.min(anchorDay, daysInMonth);
      const candidate = new Date(y, m, day);

      if (candidate > end) break;
      if (candidate >= start) {
        result.push({ year: y, month: m, day, date: candidate });
      }

      m += interval;
      while (m > 11) {
        m -= 12;
        y += 1;
      }
    }
    return result;
  };

  // ตรวจเงื่อนไข start/end date ตาม frequency — คืน { message, suggestion } ถ้าไม่ผ่าน
  validateDateRange = () => {
    const { start_date, end_date, frequency } = this.state;
    if (!start_date || !end_date) return null;

    const start = this.parseLocalDate(start_date);
    const end = this.parseLocalDate(end_date);
    if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;

    if (end < start) {
      return {
        message: t("end_before_start"),
        suggestion: t("suggest_end_from").replace("{date}", format_date(start_date, "dd/mm/yyyy", "th")),
      };
    }

    const interval = this.getFrequencyInterval(frequency);
    // วันสิ้นสุดนับรวม → ครบ interval เดือน = start + interval เดือน − 1 วัน
    const minEnd = this.parseLocalDate(this.computeDefaultEnd(start_date, frequency));

    // ต้องครบอย่างน้อย 1 รอบ (interval เดือน) — เท่ากับ 1 รอบพอดีถือว่าผ่าน
    if (end < minEnd) {
      const suggestStr = this.computeDefaultEnd(start_date, frequency);
      return {
        message: t("date_range_rule").replace("{freq}", this.getFrequencyLabel(frequency)).replace("{months}", interval),
        suggestion: t("suggest_end_from").replace("{date}", format_date(suggestStr, "dd/mm/yyyy", "th")),
      };
    }
    return null;
  };

  // คำนวณ default end date = start + 1 รอบของ frequency − 1 วัน (clamp วันที่ให้อยู่ในเดือน)
  computeDefaultEnd = (startDate, frequency) => {
    if (!startDate) return "";
    const start = this.parseLocalDate(startDate);
    if (isNaN(start.getTime())) return "";

    const interval = this.getFrequencyInterval(frequency);
    const y = start.getFullYear();
    const m = start.getMonth() + interval;
    const daysInTarget = new Date(y, m + 1, 0).getDate();
    const day = Math.min(start.getDate(), daysInTarget);
    const target = new Date(y, m, day - 1); // นับวันเริ่มต้นเป็นวันแรกของรอบ → ลบ 1 วัน

    return `${target.getFullYear()}-${("0" + (target.getMonth() + 1)).slice(-2)}-${("0" + target.getDate()).slice(-2)}`;
  };

  // เลือก start date -> ตั้ง default end date เป็น 1 รอบ + reset วันที่เข้าพบ
  onChangeStartDate = (value) => {
    this.setState({
      start_date: value,
      end_date: this.computeDefaultEnd(value, this.state.frequency),
      visit_date: "",
      visit_day: "",
    });
  };

  // เปลี่ยน frequency -> คงวันสิ้นสุดเดิม (เติมให้เมื่อว่าง) + reset วันที่เข้าพบ
  onChangeFrequency = (value) => {
    const { start_date, end_date } = this.state;
    this.setState({
      frequency: value,
      end_date: end_date || this.computeDefaultEnd(start_date, value),
      visit_date: "",
      visit_day: "",
    });
  };

  // เปลี่ยน end date ด้วยมือ -> reset วันที่เข้าพบ (เพราะช่วงเปลี่ยน)
  onChangeEndDate = (value) => {
    this.setState({ end_date: value, visit_date: "", visit_day: "" });
  };

  // เลือกวันที่คาดว่าจะเข้าพบ (เป็นวันที่จริงในช่วง start-end) -> ดึง "วันที่" มาเป็น anchor
  onChangeVisitDate = (value) => {
    const day = value ? new Date(value).getDate() : "";
    this.setState({ visit_date: value, visit_day: day ? String(day) : "" });
  };

  // เปลี่ยนลูกค้า -> reset โครงการ + asset ที่เลือกไว้
  onChangeCustomer = (value, item) => {
    this.pinCustomer(item);
    this.setState({ customer_id: value, project_id: "", asset_id: "" });
  };

  // เปลี่ยนโครงการ -> reset asset ที่เลือกไว้
  onChangeProject = (value) => {
    this.setState({ project_id: value, asset_id: "" });
  };

  toCustomerOption = (customer) => ({
    ...customer,
    group: undefined,
    value: customer.uid,
    label: this.getCustomerDisplayName(customer),
  });

  // ค้นหาลูกค้าฝั่ง server (Select เรียกให้ตอนพิมพ์) - token กันผลลัพธ์ที่ตอบช้ามาทับคำค้นล่าสุด
  customerSearchToken = 0;

  searchCustomers = async (keyword = "") => {
    const token = ++this.customerSearchToken;
    const rows = await searchCustomerRows(keyword);
    if (token !== this.customerSearchToken || rows === null) return;

    this.setState((prevState) => ({
      data_customers: mergeCustomerPins(rows.map(this.toCustomerOption), prevState.customer_pins),
    }));
  };

  // ปักหมุดลูกค้าที่เลือกไว้ ไม่ให้หายไปจากรายการเมื่อผลค้นหาเปลี่ยน
  pinCustomer = (option) => {
    if (!option?.value) return;

    this.setState((prevState) => {
      const customer_pins = addCustomerPin(prevState.customer_pins, option);
      return { customer_pins, data_customers: mergeCustomerPins(prevState.data_customers, customer_pins) };
    });
  };

  // reset ฟอร์มเมื่อปิด modal
  resetForm = () => {
    this.setState({
      modal_create: false,
      edit_uid: "",
      customer_id: "",
      project_id: "",
      asset_id: "",
      checklist_template_id: "",
      frequency: "Monthly",
      assigned_technician_id: "",
      start_date: "",
      end_date: "",
      visit_date: "",
      visit_day: "",
      notification_days: "7",
    });
  };

  // ===== บันทึก (ยังไม่บันทึกจริง — เตรียมข้อมูลแล้วรอ confirm) =====
  handleSave = async () => {
    if (this._saving) return; // กัน double submit
    const {
      customer_id,
      project_id,
      asset_id,
      checklist_template_id,
      frequency,
      assigned_technician_id,
      start_date,
      end_date,
      visit_day,
      notification_days,
    } = this.state;

    // ---- ตรวจ field บังคับ ----
    if (!customer_id) return alert("", "warning", t("warning"), t("verify_select_customer"));
    if (!project_id) return alert("", "warning", t("warning"), t("verify_select_project"));
    if (!asset_id) return alert("", "warning", t("warning"), t("verify_select_asset"));
    if (!checklist_template_id) return alert("", "warning", t("warning"), t("verify_select_checklist"));
    if (!frequency) return alert("", "warning", t("warning"), t("verify_select_frequency"));
    if (!start_date) return alert("", "warning", t("warning"), t("verify_select_start_date"));
    if (!end_date) return alert("", "warning", t("warning"), t("verify_select_end_date"));
    if (!visit_day) return alert("", "warning", t("warning"), t("verify_select_visit_day"));

    // ---- ตรวจเงื่อนไข start/end ตาม frequency (พร้อมคำแนะนำวิธีแก้) ----
    const dateError = this.validateDateRange();
    if (dateError) {
      return alert("", "warning", t("warning"), `${dateError.message}\n${dateError.suggestion}`);
    }

    // ---- คำนวณรอบเข้าพบ ----
    const schedule = this.computeSchedule();
    if (schedule.length === 0) {
      return alert("", "warning", t("warning"), t("no_visit_found"));
    }

    // ---- เตรียม payload (ชื่อ field ตรงกับ backend DTO) ----
    const body = {
      company_id: company?.id || "",     // company uid (จาก localStorage)
      customer_id,
      project_id: project_id === NO_PROJECT ? null : project_id,
      asset_id,
      checklist_template_id,
      technician_id: assigned_technician_id || undefined,
      frequency,                          // string: ดู FREQUENCY_OPTIONS
      start_date,
      end_date,
      visit_day: parseInt(visit_day, 10),
      notification_day_before: parseInt(notification_days, 10),
      is_active: true,
    };

    // ---- confirm ก่อนบันทึก ----
    const confirmed = await alert(
      "",
      "info",
      t("confirm_inspection_plan"),
      t("confirm_submission"),
      t("confirm"),
      t("cancel"),
    );

    if (!confirmed) return;

    // ---- บันทึกจริงผ่าน API (กัน double submit ด้วย flag) ----
    this._saving = true;
    this.setState({ saving: true });
    loading(true);
    let result;
    try {
      const { edit_uid } = this.state;
      result = edit_uid
        ? await PUT("admin/inspection-plans/" + edit_uid, body)
        : await POST("admin/inspection-plans", body);
    } finally {
      loading(false);
      this._saving = false;
      this.setState({ saving: false });
    }

    if (result?.status === true) {
      this.resetForm();
      await this.GetSchedule();
      alert("", "success", t("save_success_title"), t("save_success_msg"));
    } else {
      alert("", "warning", t("warning"), result?.message || t("save_error_msg"));
    }
  };

  // map สถานะ WO -> หมวดสีของวงกลม
  // draft = ยังไม่แปลงเป็น WO (เหลือง) / completed, success = ปิดงานแล้ว (เขียว)
  // สถานะอื่นที่พ้น draft แล้ว (open, in_progress ฯลฯ) = แปลงเป็น WO แล้ว (น้ำเงิน)
  mapWoStatusToColor = (woStatus) => {
    const status = String(woStatus || "draft").toLowerCase();
    if (status === "completed" || status === "success") return "completed";
    if (status === "draft") return "scheduled";
    return "upcoming";
  };

  getStatusColor = (status) => {
    switch (status) {
      case "completed": return "#198754";
      case "scheduled": return "#f59e0b";
      case "upcoming": return "#0d6efd";
      case "overdue": return "#dc3545";
      default: return "#e2e8f0";
    }
  }

  render() {
    const {
      modal_create, edit_uid, filter_search, filter_customer_uid, current_year, data, summary,
      customer_id, project_id, asset_id, checklist_template_id, frequency,
      assigned_technician_id, start_date, end_date, visit_date, notification_days,
      data_customers, data_technicians, data_checklists,
    } = this.state;

    // ย้าย months มาไว้ใน render เพื่อให้แปลภาษาแบบ dynamic ได้
    const monthHeaders = [
      t("jan_short"), t("feb_short"), t("mar_short"), t("apr_short"),
      t("may_short"), t("jun_short"), t("jul_short"), t("aug_short"),
      t("sep_short"), t("oct_short"), t("nov_short"), t("dec_short")
    ];

    // ===== คำนวณข้อมูลสำหรับ modal แบบ live =====
    const projectOptions = this.getProjectOptions();
    const filteredAssetOptions = this.getFilteredAssetOptions();
    const schedulePreview = this.computeSchedule();
    const dateError = this.validateDateRange();

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
          <div className="d-flex flex-wrap justify-content-between align-items-start mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1">{t("inspection_master_plan")}</h3>
              <div className="text-secondary">{t("annual_pm_schedule")}</div>
            </div>
            
            <div className="d-flex gap-3 align-items-center">
              <div className="d-flex align-items-center bg-white border rounded-3 px-2 py-2 shadow-sm">
                <button className="btn btn-sm btn-white border-0 text-secondary py-0" onClick={() => this.changeYear(-1)}><span className="icon">{"\uf053"}</span></button>
                <div className="fw-bold text-dark px-3 text-16">{current_year}</div>
                <button className="btn btn-sm btn-white border-0 text-secondary py-0" onClick={() => this.changeYear(1)}><span className="icon">{"\uf054"}</span></button>
              </div>

              {can("inspection-plan.create") ? (
              <button 
                className="btn btn-primary fw-bold px-3 py-2 rounded-3 shadow-sm d-flex align-items-center"
                onClick={this.openCreate}
              >
                <span className="me-2">+</span> {t("add_plan")}
              </button>
              ) : null}
            </div>
          </div>

          {/* KPI Cards */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border border-primary-light rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #0d6efd !important" }}>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="text-secondary text-14 mb-1">{t("total_inspections")}</div>
                    <h2 className="fw-bold mb-1 text-dark">{formatNumber(summary.total)}</h2>
                    <div className="text-secondary text-12">{t("this_year")}</div>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">
                    {"\uf274"}
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-6">
              <div className="card border border-success-light rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #198754 !important" }}>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="text-secondary text-14 mb-1">{t("completed")}</div>
                    <h2 className="fw-bold mb-1 text-success">{formatNumber(summary.completed)}</h2>
                    <div className="text-success text-12">
                      <span className="icon me-1">{"\uf00c"}</span> {summary.total ? Math.round((summary.completed / summary.total) * 100) : 0}% {t("done")}
                    </div>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">
                    {"\uf058"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border border-primary-light rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #0d6efd !important" }}>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="text-secondary text-14 mb-1">{t("upcoming_7_days")}</div>
                    <h2 className="fw-bold mb-1 text-primary">{formatNumber(summary.upcoming)}</h2>
                    <div className="text-primary text-12">
                      <span className="icon me-1">{"\uf017"}</span> {t("needs_attention")}
                    </div>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">
                    {"\uf252"}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border border-danger-light rounded-4 shadow-sm p-3 h-100" style={{ borderLeft: "4px solid #dc3545 !important" }}>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="text-secondary text-14 mb-1">{t("overdue")}</div>
                    <h2 className="fw-bold mb-1 text-danger">{formatNumber(summary.overdue)}</h2>
                    <div className="text-danger text-12">
                      <span className="icon me-1">{"\uf071"}</span> {t("action_required")}
                    </div>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-danger-light text-danger d-flex align-items-center justify-content-center text-18 icon">
                    {"\uf071"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="bg-white rounded-4 shadow-sm pb-2">
            
            {/* Filter Toolbar */}
            <div className="p-3 border-bottom d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex flex-wrap gap-2 flex-grow-1 align-items-center">
                <div className="position-relative" style={{ maxWidth: "250px", width: "100%" }}>
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                  <input
                    type="text"
                    className="form-control ps-5 rounded-3"
                    placeholder={t("search_machines")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                    onKeyDown={(e) => { if (e.key === "Enter") this.GetSchedule(); }}
                  />
                </div>
                <div className="wpx-200">
                  <Select
                    className="form-control rounded-3"
                    options={data_customers}
                    onSearch={this.searchCustomers}
                    value={filter_customer_uid}
                    onChange={(value, item) => {
                      this.pinCustomer(item);
                      this.setState({ filter_customer_uid: value });
                    }}
                    placeholder={t("all_customers")}
                  />
                </div>
                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.GetSchedule()}>
                  {t("filter")}
                </button>
                <button
                  className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                  onClick={() => this.setState({ filter_search: "", filter_customer_uid: "" }, () => this.GetSchedule())}
                >
                  {t("clear_all")}
                </button>
              </div>

              {/* Legend */}
              <div className="d-flex flex-wrap gap-3 text-12 text-secondary">
                <div className="d-flex align-items-center"><div className="wpx-10 hpx-10 rounded-circle me-1" style={{backgroundColor: "#f59e0b"}}></div> {t("scheduled")}</div>
                <div className="d-flex align-items-center"><div className="wpx-10 hpx-10 rounded-circle me-1" style={{backgroundColor: "#198754"}}></div> {t("completed")}</div>
                <div className="d-flex align-items-center"><div className="wpx-10 hpx-10 rounded-circle me-1" style={{backgroundColor: "#0d6efd"}}></div> {t("upcoming")}</div>
                <div className="d-flex align-items-center"><div className="wpx-10 hpx-10 rounded-circle me-1" style={{backgroundColor: "#dc3545"}}></div> {t("overdue")}</div>
              </div>
            </div>

            {/* Table Area */}
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "1200px" }}>
                <thead>
                  <tr className="text-dark fw-bold text-12 border-bottom">
                    <th className="py-3 px-4 border-0 wpx-250"><span className="icon me-2 text-secondary">{"\uf013"}</span> {t("machine_asset")}</th>
                    {monthHeaders.map((m, i) => <th key={i} className="py-3 text-center border-0">{m}</th>)}
                    <th className="py-3 text-center border-0 wpx-60">{t("total")}</th>
                    <th className="py-3 text-center border-0 wpx-60">{t("action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, idx) => (
                    <tr key={idx} className="border-bottom">
                      <td className="py-3 px-4">
                        <div className="wpx-250" style={{ maxWidth: "250px" }}>
                          <div className="fw-bold text-dark text-14 text-truncate" title={item.name}>{item.name}</div>
                          <div className="text-secondary text-10 text-truncate" title={item.sub}>{item.sub}</div>
                        </div>
                      </td>
                      {/* Months Columns */}
                      {monthHeaders.map((_, mIdx) => {
                        const monthData = item.schedule.find(s => s.m === mIdx);
                        return (
                          <td key={mIdx} className="text-center">
                            {monthData ? (
                              <div
                                className="wpx-25 hpx-25 rounded-circle text-white d-flex align-items-center justify-content-center mx-auto text-10 fw-bold pointer shadow-sm"
                                style={{ backgroundColor: this.getStatusColor(monthData.status), cursor: "pointer" }}
                                title={
                                  monthData.date
                                    ? `${format_date(monthData.date, "dd/mm/yyyy", this.getCurrentLang() === "EN" ? "en" : "th")} · ${t("work_order_detail")}`
                                    : t("work_order_detail")
                                }
                                onClick={() => this.openWorkOrder(monthData.wo_uid)}
                                role="button"
                              >
                                {monthData.val}
                              </div>
                            ) : (
                              <div className="text-secondary">-</div>
                            )}
                          </td>
                        );
                      })}
                      <td className="text-center">
                        <span className="badge bg-primary-light text-primary rounded-pill px-2 py-1">
                          {formatNumber(item.total)}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-2 justify-content-center">
                          {can("inspection-plan.update") ? (
                          <ActionIconButton label={t("edit")} icon={ACTION_ICONS.edit} variant="warning" onClick={() => this.openEdit(item.plan_uid)} />
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {/* Table Footer */}
            <div className="d-flex justify-content-between align-items-center p-3 text-secondary text-12 border-top">
              <div>{t("showing")} {formatNumber(data.length)} {t("machines_count")}</div>
              <div>{t("click_dot_to_view")}</div>
            </div>

          </div>
        </div>

        {/* MODAL: CREATE INSPECTION PLAN */}
        <Modal
          size="lg"
          show={modal_create}
          onHide={this.resetForm}
          centered
        >
          <Modal.Header className="border-bottom-0 pb-0 px-4 pt-4" closeButton>
            <div>
              <h4 className="fw-bold mb-1 text-dark">{edit_uid ? t("edit_inspection_plan") : t("create_inspection_plan")}</h4>
              <div className="text-secondary text-14">{t("inspection_plan_subtitle")}</div>
            </div>
          </Modal.Header>
          <Modal.Body className="pt-4 pb-4 px-4">
            <div className="row g-3">

              {/* Customer */}
              <div className="col-12">
                <label className="form-label text-14 text-dark fw-bold mb-2">
                  {t("customer")} <span className="text-danger ms-1">*</span>
                </label>
                <Select
                  className="form-control"
                  options={data_customers}
                  onSearch={this.searchCustomers}
                  value={customer_id}
                  onChange={(value, item) => this.onChangeCustomer(value, item)}
                  placeholder={t("select_customer")}
                />
              </div>

              {/* Project */}
              <div className="col-12">
                <label className="form-label text-14 text-dark fw-bold mb-2">
                  {t("label_project")} <span className="text-danger ms-1">*</span>
                </label>
                <Select
                  className="form-control"
                  options={projectOptions}
                  value={project_id}
                  onChange={(value) => this.onChangeProject(value)}
                  placeholder={customer_id ? t("select_project") : t("select_customer_first")}
                  disabled={!customer_id}
                />
              </div>

              {/* Machine / Asset */}
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("machine_asset")} <span className="text-danger">*</span></label>
                <Select
                  className="form-control"
                  options={filteredAssetOptions}
                  value={asset_id}
                  onChange={(value) => this.setState({ asset_id: value })}
                  placeholder={!customer_id ? t("select_customer_first") : project_id ? t("select_asset") : t("select_project_first")}
                  disabled={!customer_id || !project_id}
                />
              </div>

              {/* Checklist Template */}
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("checklist_template")} <span className="text-danger">*</span></label>
                <Select
                  className="form-control"
                  // เลือกสร้างใหม่ได้เฉพาะเทมเพลต Active (เทมเพลตที่เลือกไว้เดิมยังแสดงตอนแก้ไข)
                  options={data_checklists.filter((ck) => (ck.status ? ck.status === "active" : ck.is_active !== false) || ck.value === checklist_template_id)}
                  value={checklist_template_id}
                  onChange={(value) => this.setState({ checklist_template_id: value })}
                  placeholder={t("select_template")}
                />
              </div>

              {/* Frequency */}
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("frequency")} <span className="text-danger">*</span></label>
                <Select
                  className="form-control"
                  options={FREQUENCY_OPTIONS.map((f) => ({ value: f.value, label: t(f.labelKey) }))}
                  value={frequency}
                  onChange={this.onChangeFrequency}
                  placeholder={t("select_frequency")}
                  default={false}
                />
              </div>

              {/* Assigned Technician (ตัด Auto-assign ออก แสดงช่างจริง) */}
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("assigned_technician")}</label>
                <Select
                  className="form-control"
                  options={activeOptions(data_technicians, assigned_technician_id, { isActive: isTechnicianActive })}
                  value={assigned_technician_id}
                  onChange={(value) => this.setState({ assigned_technician_id: value })}
                  placeholder={t("select_technician")}
                />
              </div>

              {/* Start Date (เลือกแล้ว end date จะตั้ง default = 1 รอบของ frequency) */}
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("start_date")} <span className="text-danger ms-1">*</span></label>
                <DatePicker
                  type="th"
                  className="form-control py-2 text-dark"
                  value={start_date}
                  onChange={this.onChangeStartDate}
                  placeholder={t("date_placeholder")}
                />
              </div>

              {/* End Date (default = start + 1 รอบ, ปรับเองได้) */}
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("end_date")} <span className="text-danger ms-1">*</span></label>
                <DatePicker
                  type="th"
                  className="form-control py-2 text-dark"
                  value={end_date}
                  onChange={this.onChangeEndDate}
                  placeholder={t("date_placeholder")}
                  min={start_date || undefined}
                />
              </div>

              {/* วันที่คาดว่าจะเข้าพบ (เลือกเป็นวันที่ในช่วง start-end) = วันตั้งต้นของรอบ */}
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("expected_visit_date")} <span className="text-danger">*</span></label>
                <DatePicker
                  type="th"
                  className="form-control py-2 text-dark"
                  value={visit_date}
                  onChange={this.onChangeVisitDate}
                  placeholder={t("date_placeholder")}
                  min={start_date || undefined}
                  max={end_date || undefined}
                  disabled={!start_date || !end_date}
                />
                <div className="text-secondary mt-1" style={{ fontSize: '12px' }}>
                  {t("visit_day_hint")}
                </div>
              </div>

              {/* Notification */}
              <div className="col-md-6">
                <label className="form-label text-14 text-dark fw-bold mb-2">{t("notification_days_before")}</label>
                <Select
                  className="form-control"
                  options={[
                    { value: "1", label: `1 ${t("day_unit")}` },
                    { value: "3", label: `3 ${t("day_unit")}` },
                    { value: "7", label: `7 ${t("day_unit")}` },
                    { value: "14", label: `14 ${t("day_unit")}` },
                    { value: "30", label: `30 ${t("day_unit")}` },
                  ]}
                  value={notification_days}
                  onChange={(value) => this.setState({ notification_days: value })}
                  placeholder={t("select")}
                  default={false}
                />
              </div>

              {/* คำเตือนเงื่อนไขวันที่ (พร้อมวิธีแก้) */}
              {dateError && (
                <div className="col-12">
                  <div className="p-3 rounded-3" style={{ backgroundColor: '#fef2f2', borderLeft: '3px solid #ef4444' }}>
                    <div className="text-danger fw-bold text-14">{dateError.message}</div>
                    <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{dateError.suggestion}</div>
                  </div>
                </div>
              )}

              {/* Schedule Preview (คำนวณจริงตาม frequency + วันที่เข้าพบ) */}
              <div className="col-12 mt-3">
                <div className="rounded-3 p-4" style={{ backgroundColor: '#f9fafb' }}>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="text-dark fw-bold text-14">{t("schedule_preview")}</div>
                    {schedulePreview.length > 0 && (
                      <span className="badge bg-primary-light text-primary rounded-pill px-3 py-1">
                        {formatNumber(schedulePreview.length)} {t("visits_count")}
                      </span>
                    )}
                  </div>

                  {schedulePreview.length > 0 ? (
                    <div className="d-flex flex-wrap gap-2 mb-3">
                      {schedulePreview.map((s, i) => (
                        <span key={i} className="badge rounded-pill fw-bold px-3 py-2 text-13 shadow-sm" style={{ backgroundColor: "#f59e0b", color: "#fff" }}>
                          {monthHeaders[s.month]} {s.year}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <div className="text-secondary mb-3" style={{ fontSize: '13px' }}>
                      {t("no_schedule_hint")}
                    </div>
                  )}

                  <div className="p-2 text-primary d-flex align-items-center" style={{ backgroundColor: '#eff6ff', borderLeft: '3px solid #3b82f6', fontSize: '13px', borderRadius: '0 4px 4px 0' }}>
                    {t("schedule_preview_hint")}
                  </div>
                </div>
              </div>

            </div>
          </Modal.Body>
          <Modal.Footer className="border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end gap-2 bg-white">
            <button
              className="btn btn-white px-4 py-2 text-dark border border-secondary-light rounded-3 fw-medium"
              onClick={this.resetForm}
            >
              {t("cancel")}
            </button>
            <button
              className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-medium"
              onClick={this.handleSave}
              disabled={this.state.saving}
            >
              <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
            </button>
          </Modal.Footer>
        </Modal>

      </div>
    );
  }
}